var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.6 31.6",
    style: {
      enableBackground: "new 0 0 31.6 31.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#5D5F74;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.3,19c0.2-1,0.3-2.1,0.3-3.2C31.6,7.1,24.5,0,15.8,0S0,7.1,0,15.8s7.1,15.8,15.8,15.8 c1.1,0,2.1-0.1,3.2-0.3c0.6-0.1,1-0.7,0.9-1.3c-0.1-0.6-0.7-1-1.3-0.9c-0.9,0.2-1.8,0.3-2.7,0.3c-7.5,0-13.6-6.1-13.6-13.6 S8.3,2.2,15.8,2.2s13.6,6.1,13.6,13.6c0,0.9-0.1,1.8-0.3,2.7c-0.1,0.6,0.3,1.2,0.9,1.3C30.6,20,31.2,19.6,31.3,19L31.3,19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,7.7v6.9l-5.6,5.6c-0.4,0.4-0.4,1.1,0,1.6c0.4,0.4,1.1,0.4,1.6,0l5.9-5.9c0.2-0.2,0.3-0.5,0.3-0.8V7.7 c0-0.6-0.5-1.1-1.1-1.1C15.9,6.6,15.4,7.1,15.4,7.7L15.4,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.2,17.7c-3,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5S26.2,17.7,23.2,17.7z M23.2,19.9 c1.8,0,3.3,1.5,3.3,3.3s-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3S21.3,19.9,23.2,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.3,29.8l-3.7-3.7c-0.4-0.4-1.1-0.4-1.6,0c-0.4,0.4-0.4,1.1,0,1.6l3.7,3.7c0.4,0.4,1.1,0.4,1.6,0 C31.7,30.9,31.7,30.2,31.3,29.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/historyIcon.dc4fb6e731f17f61d9f2f25fefa8c737.svg";
export { ForwardRef as ReactComponent };